import React from 'react';

const CatalogoProductosSpc = () => {
  return (
    <section>
      <div className="container">
        <div className="title-style2 text-center mb-2-2 wow fadeIn" data-wow-delay="200ms">
          <h2 className="h1">Catálogo Modelos Piso SPC Económico</h2>
        </div>
        <div className="row mt-n1-9">
          {/* Producto 1 */}
          <Producto
            imgSrc="/assets/img/productos/pisos-spc/piso-spc-catalogo-lq5182-12.jpg"
            altText="Piso SPC catalogo LQ5182-12"
            codigo="PINO"
            tipo="Piso SPC"
            delay="100ms"
          />
          {/* Producto 2 */}
          <Producto
            imgSrc="/assets/img/productos/pisos-spc/piso-spc-catalogo-ld1101624.jpg"
            altText="piso spc catalogo Fresno"
            codigo="FRESNO"
            tipo="Piso SPC"
            delay="200ms"
          />
          {/* Producto 3 */}
          <Producto
            imgSrc="/assets/img/productos/pisos-spc/piso-spc-catalogo-ld1205203.jpg"
            altText="piso spc catalogo LD1205203"
            codigo="MAPLE"
            tipo="Piso SPC"
            delay="300ms"
          />
          {/* Producto 4 */}
          <Producto
            imgSrc="/assets/img/productos/pisos-spc/piso-spc-catalogo-ld1205209.jpg"
            altText="piso spc catalogo LD1205209"
            codigo="BLANCO"
            tipo="Piso SPC"
            delay="400ms"
          />
        </div>
      </div>
    </section>
  );
};

// Componente para cada producto
const Producto = ({ imgSrc, altText, codigo, tipo, delay }) => {
  return (
    <div className={`col-sm-6 col-lg-3 mt-1-9 wow fadeInUp`} data-wow-delay={delay}>
      <div className="card card-style3 border-0 text-center">
        <div className="card-img position-relative">
          <img src={imgSrc} className="card-img-top" alt={altText} />
        </div>
        <div className="card-body p-1-9">
          <h3 className="h5">{codigo}</h3>
          <p className="text-primary mb-0">{tipo}</p>
        </div>
      </div>
    </div>
  );
};

export default CatalogoProductosSpc;
